import { AgendaEventModel } from 'components/agenda'

export interface EventoAgendaProfissional extends AgendaEventModel {
  tipo: 'consulta' | 'reserva' | 'sem_configuracao' | 'fechamento'
}

export interface AgendamentoReservaModel {
  horarioInicio: string
  horarioFinal: string
  data: LocalDate
  motivo: MotivoReservaEnum
  motivoEspecifico: string
  observacoes: string
}

export enum MotivoReservaEnum {
  REUNIAO = 'REUNIAO',
  ATENDIMENTO_EXTERNO = 'ATENDIMENTO_EXTERNO',
  ATIVIDADE_COLETIVA = 'ATIVIDADE_COLETIVA',
  OUTROS = 'OUTROS',
}
